import { createContext, PropsWithChildren, useContext, useState } from "react";

interface CheckBoxGroupContextReturn {
    variant?:"list"|"collapse",
    checkBoxes:string[],
    register:(name:string)=>void,
    unregister:(name:string)=>void
}

const FormGroupContext = createContext<CheckBoxGroupContextReturn>({
    variant:undefined,
    checkBoxes:[],
    register:()=>{},
    unregister:()=>{}
});

export function useCheckBoxGroupContext(){
    return useContext(FormGroupContext);
}

export interface CheckBoxGroupGroupProviderProps extends PropsWithChildren{
    variant:"list"|"collapse"
}

export function CheckBoxGroupGroupProvider({
    variant,
    children
}:CheckBoxGroupGroupProviderProps){
    const {register:parentRegister, unregister:parentUnregister} = useCheckBoxGroupContext();
    const [checkBoxes, setCheckBoxes] = useState<{[key:string]:true}>({});

    const register = (name:string)=>{
        setCheckBoxes(prev=>({...prev, [name]:true}));
        parentRegister(name);
    }

    const unregister = (name:string)=>{
        setCheckBoxes(prev=>{
            const newPrev = {...prev};
            delete newPrev[name];
            return newPrev;
        });
        parentUnregister(name);
    }

    return <FormGroupContext.Provider value={{
        variant,
        checkBoxes:Object.keys(checkBoxes),
        register,
        unregister
    }}>
        {children}
    </FormGroupContext.Provider>
}